Object.defineProperty(exports, '__esModule', { value: true });

const DEFAULT_HOOKS = ['activate', 'mount', 'update'];

exports.DEFAULT_HOOKS = DEFAULT_HOOKS;
//# sourceMappingURL=constants.js.map
